import { sortByDataVoiceSMS } from './sort-options';

export const defaultIfEmpty = (options: Object[]): Object[] =>
  !!options.length
    ? options
    : [
        {
          type: 'DATA',
        },
        {
          type: 'VOICE',
        },
        {
          type: 'SMS',
        },
      ];

export const getFormattedOptionsWithDefault = (options: Object[]): Object[] =>
  getFormattedOptions(defaultIfEmpty(options));

export const getFormattedOptions = (options: Object[]): Object => {
  let creditable: Object[] = [];
  let service: Object[] = [];

  for (const option of options) {
    if (option.type !== 'DEFAULT') {
      creditable.push(option);
    } else {
      service.push(option);
    }
  }
  // Added 0Go DATA or ROA_DATA or ZONED_VOICE options if not present in order to display them in PlanSummary as 0Go/0min 
  // because they are not present in the triPica API response / catalog
  const hasZeroDataOption = creditable.some(option => option.type === 'DATA');
  const hasRoamingDataOption = creditable.some(option => /^ROA{1,2}\d_DATA$/.test(option.type));
  const hasZonedVoiceOption = creditable.some(option => option.type === 'TO_ZONED_VOICE');

  if (!hasZeroDataOption) {
    creditable.push({
      type: 'DATA',
      characteristic: { unit: 'VOLUME', value: '0' },
    });
  }

  if (!hasRoamingDataOption) {
    creditable.push({
      type: 'ROA_DATA',
      characteristic: { unit: 'VOLUME', value: '0' },
    });
  }

  if (!hasZonedVoiceOption) {
    creditable.push({
      type: 'TO_ZONED_VOICE',
      characteristic: { unit: 'DURATION', value: '0' },
    });
  }

  const sortedCreditableOptions = creditable.sort((creditableOption1, creditableOption2) =>
    sortByDataVoiceSMS(creditableOption1.type, creditableOption2.type)
  );

  return {
    creditable: sortedCreditableOptions,
    service,
  };
};

export const getSecondaryCharacteristicsForOptions = (options: Object[]) => {
  const secondaryCharacteristicsOptions: Object[] = [];
  const primaryCharacteristics = ['SMS_CREDIT', 'DATA_CREDIT', 'VOICE_CREDIT'];

  options.forEach(option => {
    const { characteristics } = option;
    const isPrimaryCharacteristic = characteristics?.some(characteristic =>
      primaryCharacteristics.includes(characteristic.name)
    );
    if (isPrimaryCharacteristic) {
      secondaryCharacteristicsOptions.push(
        ...option.characteristics.filter(characteristic => !primaryCharacteristics.includes(characteristic.name))
      );
    }
  });

  return secondaryCharacteristicsOptions;
};
